import "./App.css";
import { CookiesProvider } from "react-cookie";
import AppRoutes from "./routes";
import "@coreui/coreui/dist/css/coreui.min.css";
import { ThemeProvider } from "styled-components";
import themes from "./styles/theme/themes";
import GlobalContextWrapper from "./context/globalContext";
import ServiceContextWrapper from "./context/serviceContext";

function App() {
  return (
    <CookiesProvider>
      <ThemeProvider theme={themes}>
        <GlobalContextWrapper>
          <ServiceContextWrapper>
            <AppRoutes />
          </ServiceContextWrapper>
        </GlobalContextWrapper>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
